import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  barChart: {
    marginTop: '2em',
  },
}))

export { useStyles }
